import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import Resources from '../../core/constants/resources';
import { SessionStorageService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private sessionService: SessionStorageService) {

  }

  canActivate(): boolean {
    if (!!this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.SpendId)) {
      return true;
    } else {
      return false;
    }
  }
}

